import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductsService } from '../../../../../services/products.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-product-panel',
  templateUrl: './add-product-panel.component.html',
  styleUrls: ['./add-product-panel.component.scss'],
})
export class AddProductPanelComponent implements OnInit {
  @Output() update = new EventEmitter();

  public product: any = {
    taxable: true,
    defaultPrice: '',
    name: '',
  };
  public vatInclusive = false;
  public vatRate = 0.0;
  public editingSKU = false;
  public skuExists = false;
  public saving = false;
  public currencySymbol = '';
  public currencyoptions: any = {
    prefix: '',
  };

  constructor(
    private productsService: ProductsService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {}

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 250;

  ngOnInit() {
    this.vatInclusive = this.helpersService.getPartnerData().VATInclusive;
    this.vatRate = this.helpersService.getPartnerData().VATRate * 100;
    this.currencySymbol =
      this.helpersService.getPartnerData().CurrencySymbol + ' ';
    this.currencyoptions.prefix = this.currencySymbol;

    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.searchProducts();
      });
  }

  inputChanged() {
    this.modelChanged.next('');
  }

  searchProducts() {
    this.productsService
      .checkSKUExists({
        SKU: this.product.sku,
        PartnerID: this.helpersService.getPartnerId(),
        ProductID: this.product.id,
      })
      .subscribe(
        (result) => {
          this.skuExists = true;
        },
        (err) => {
          this.skuExists = false;
        },
      );
  }

  valid() {
    return !!(
      !this.skuExists &&
      this.product.name &&
      this.product.name.length > 0 &&
      this.product.defaultPrice !== null &&
      this.product.defaultPrice.toString().length > 0
    );
  }

  save() {
    this.saving = true;
    this.addProduct();
  }

  addProduct() {
    var data = {
      ...this.product,
      partnerID: this.helpersService.getPartnerId(),
    };

    this.productsService.createSingleProduct(data).subscribe(
      (res) => {
        this.saving = false;
        this.update.emit(res);
        setTimeout(() => {
          this.product = {
            taxable: true,
            defaultPrice: '',
            name: '',
          };
        }, 250);
      },
      (err) => {
        this.saving = false;
      },
    );
  }
}
